/* eslint-disable sonarjs/no-duplicate-string */
import { __ } from '../../../i18n/l10n';
import { GRRounds } from '../types/round';

// __('You will earn between %1$s and %2$s times your reference bet in Freebets.')
// __('Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.')
export const getGRRulesByRound = (maxPoints: number, minStakeMultiplicator: number, maxStakeMultiplicator: number) => ({
  [GRRounds.SHOE]: {
    title: __('Phase 1: Pegasus Shoes'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('And you will unlock phase 2.')}</>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
  [GRRounds.BALLOON]: {
    title: __('Phase 2: The remote control ball'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('And you will unlock phase 3.')}</>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
  [GRRounds.SHIRT]: {
    title: __('Phase 3: The Chameleon Jersey'),
    rules: [
      <>{__('Place a series of winning bets to score %1$s points.', maxPoints)}</>,
      <>
        {__(
          'Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.',
        )}
      </>,
      <>
        {__('You will earn between %1$s and %2$s times your reference bet in Freebets.', [
          minStakeMultiplicator,
          maxStakeMultiplicator,
        ])}
      </>,
      <>{__('If you lose a bet, you start the phase from 0.')}</>,
    ],
  },
});
